
import React from 'react';
import SigniteButton from '../../../ui-elements/signite-button/signiteButton';
import { Modal, Row, Col, Container, Form } from 'react-bootstrap';
import './forgotPassword.css';
export const VerifyOtpDialog = ({ show, setShow, flowConfig, otp, setOtp, usernameOrEmail }) => {
  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const otpArray = otp ? otp.split('') : ['', '', '', ''];
    otpArray[index] = value;
    setOtp(otpArray.join(''));
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered >
      <Modal.Header closeButton className='forgot-pwd-close'>
        <Modal.Title style={{ textAlign: 'center', width: '100%', color: '#2D3E50', fontFamily: 'Poppins', fontWeight: 600 }}>
          OTP sent to Registered Email ID
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="otp-password-body">
        <Container>
          <Row className="d-flex align-items-center justify-content-center text-center otp-row">
            <Col xs={12} className="p-2">
              {/* Enter The 4-Digit OTP Sent to <span className="otp-mobile-no"> &nbsp; {usernameOrEmail}</span> */}
              Enter The 4-Digit OTP sent to your Registered Email ID

            </Col>
            <Row className="d-flex justify-content-center flex-nowrap">
              {[0, 1, 2, 3].map((index) => (
                <Col key={index} xs="auto" className="otp-col">
                  <Form.Control
                    className="otpInput"
                    style={{
                      boxShadow: 'none',
                      textAlign: 'center',
                      width: '50px',
                      minWidth: '50px'
                    }}

                    maxLength="1"
                    value={otp[index] || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleOtpChange(index, value);
                      if (value && index < 3) {
                        document.getElementById(`otp-${index + 1}`)?.focus();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !otp[index] && index > 0) {
                        document.getElementById(`otp-${index - 1}`)?.focus();
                      }
                    }}
                    id={`otp-${index}`}
                  />
                </Col>
              ))}
            </Row>


          </Row>
          <Row>
            <Col className="p-2 d-flex align-items-center justify-content-center">
              <SigniteButton
                variant={'primary'}
                className=" verifyotp-button mt-3 p-3"
                disabled={otp.length !== 4}
                onClick={() => flowConfig.verify(usernameOrEmail, otp)}
              >
                Verify
              </SigniteButton>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};
